import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gift-card-girl-banner" }
const _hoisted_2 = { class: "container header-padding-compensation" }
const _hoisted_3 = { class: "image-container" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: {name: 'GiftCertificate'} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("picture", null, [
                _createElementVNode("source", {
                  media: "only screen and (min-width: 1200px)",
                  srcset: _ctx.$imgix('img/gift_card_banner_girl.jpg?w=1110&h=400&auto=compress,format&fit=crop')
                }, null, 8, _hoisted_4),
                _createElementVNode("source", {
                  media: "only screen and (min-width: 992px)",
                  srcset: _ctx.$imgix('img/gift_card_banner_girl.jpg?w=1110&h=400&auto=compress,format&fit=crop')
                }, null, 8, _hoisted_5),
                _createElementVNode("source", {
                  media: "only screen and (min-width: 768px)",
                  srcset: _ctx.$imgix('img/gift_card_banner_girl.jpg?w=1110&h=400&auto=compress,format&fit=crop')
                }, null, 8, _hoisted_6),
                _createElementVNode("source", {
                  media: "only screen and (min-width: 576px)",
                  srcset: _ctx.$imgix('img/gift_card_banner_girl.jpg?w=1110&h=400&auto=compress,format&fit=crop')
                }, null, 8, _hoisted_7),
                _createElementVNode("img", {
                  src: _ctx.$imgix('img/gift_card_banner_girl.jpg?w=1110&h=400&auto=compress,format&fit=crop'),
                  alt: _ctx.$t('website.banner-image'),
                  width: "1110",
                  height: "400"
                }, null, 8, _hoisted_8)
              ])
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}